import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cross",
  "use": "svg-icon-cross-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\" id=\"svg-icon-cross\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M1 9l8-8M9 9L1 1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol